<template>
  <nuxt-layout name="common"><AccountPage /></nuxt-layout>
</template>
<script lang="ts" setup>
const { t } = useI18n();
useWebsiteHead({ title: t('title.account') });
</script>
